import React, { useRef, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Menu from "./components/Menu";
import Home from "./components/Home";
import About from "./components/About";
import Services from "./components/Services";
import Portfolio from "./components/Portfolio";
import OurTeam from "./components/OurTeam";
import ContactUs from "./components/ContactUs";
import Footer from "./components/Footer";
import CustomCursor from "./components/CustomCursor";
import CV from "./components/CV";
import OpenService from "./components/OpenService";

function App() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    let particles = [];
    let animationFrameId;

    const particleColors = [
      "rgba(220,50,50,0.6)",
      "rgba(50,100,220,0.6)",
      "rgba(255,223,0,0.7)",
      "rgba(50,150,255,0.6)",
    ];

    const PARTICLE_CONFIG = {
      minRadius: 3,
      maxRadius: 7,
      minSpeed: 0.5,
      maxSpeed: 1.2,
      baseCount: 120,
    };

    const createParticles = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      canvas.width = width;
      canvas.height = height;

      const scaleFactor = width / 1920;
      const particleCount = Math.floor(PARTICLE_CONFIG.baseCount * scaleFactor);

      particles = [];

      for (let i = 0; i < particleCount; i++) {
        // ✅ FIX: Ensure radius is always positive and within bounds
        const minRadius = Math.max(0.5, PARTICLE_CONFIG.minRadius);
        const maxRadius = Math.max(minRadius + 0.5, PARTICLE_CONFIG.maxRadius);
        
        let radius = minRadius + Math.random() * (maxRadius - minRadius);
        radius = Math.max(0.5, Math.min(radius, maxRadius)); // Double-check bounds
        
        const speed =
          PARTICLE_CONFIG.minSpeed +
          Math.random() *
            (PARTICLE_CONFIG.maxSpeed - PARTICLE_CONFIG.minSpeed);

        particles.push({
          x: Math.random() * width,
          y: Math.random() * height,
          radius: radius,
          dx: (Math.random() - 0.5) * speed,
          dy: (Math.random() - 0.5) * speed,
          color:
            particleColors[
              Math.floor(Math.random() * particleColors.length)
            ],
        });
      }
    };

    createParticles();

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach((p) => {
        // ✅ FIX: Skip particles with invalid radius
        if (!p.radius || p.radius <= 0) return;
        
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
        ctx.fillStyle = p.color;
        ctx.fill();

        p.x += p.dx;
        p.y += p.dy;

        if (p.x < 0 || p.x > canvas.width) p.dx = -p.dx;
        if (p.y < 0 || p.y > canvas.height) p.dy = -p.dy;
        
        // ✅ FIX: Clamp radius to positive values
        if (p.radius < 0.5) p.radius = 0.5;
      });

      animationFrameId = requestAnimationFrame(draw);
    };

    draw();

    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
      createParticles();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <Router>
      <div style={{ position: "relative", minHeight: "100vh" }}>
        <canvas
          ref={canvasRef}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: -1,
            pointerEvents: "none",
          }}
        />

        <CustomCursor />
        <Menu />

        <Routes>
          <Route path="/service/:id" element={<OpenService />} />
          <Route
            path="/"
            element={
              <main style={{ position: "relative", zIndex: 1 }}>
                <Home />
                <About />
                <Services />
                <Portfolio />
                <OurTeam />
                <ContactUs />
                <Footer />
              </main>
            }
          />
          <Route path="/cv" element={<CV />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;